module.exports = {"TXTACL_My_Bets":{"id":"TXTACL_My_Bets","defaultMessage":"Pariurile mele"}}